const master = {
  vendor: {
    regular: {
      list: '/vendor/regular-vendor',
      create: '/vendor/regular-vendor/new',
      detail: id => `/vendor/regular-vendor/detail/${id}`,
      update: id => `/vendor/regular-vendor/update/${id}`
    },
    trucker: {
      list: '/vendor/trucker-vendor',
      create: '/vendor/trucker-vendor/new',
      detail: id => `/vendor/trucker-vendor/detail/${id}`,
      update: id => `/vendor/trucker-vendor/update/${id}`
    },
    fuelRetailer: {
      list: '/vendor/fuel-retailer-vendor',
      create: '/vendor/fuel-retailer-vendor/new',
      detail: id => `/vendor/fuel-retailer-vendor/detail/${id}`,
      update: id => `/vendor/fuel-retailer-vendor/update/${id}`
    }
  },
  vehicle: {
    list: '/vehicle',
    create: '/vehicle/new',
    detail: id => `/vehicle/detail/${id}`,
    update: id => `/vehicle/update/${id}`
  },
  location: {
    branch: '/location/branch',
    location: '/location/location',
    route: '/location/route'
  },
  customer: {
    list: '/customer',
    create: '/customer/new',
    detail: id => `/customer/detail/${id}`,
    update: id => `/customer/update/${id}`
  }
};

export default master;
